import e from"../../node_modules/lodash-es/get.js";var l=l=>o=>e(l,o,null);export{l as getNullableField};
//# sourceMappingURL=getNullableField.js.map